<template>
<div class="popup" v-show="optionDialogShow" v-cloak>
    <div class="content" id="taskTransferOptions">
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.cloudTransfer.transfer')" name="first">
                        <tab1 ref="tab1"></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.email')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label" name="third" class="transfer-vip">
                            <span>{{$t('language.popup.filter')}}</span>
                            <div class="icon-util vip filter-position"></div>
                        </span>
                        <tab3 ref="tab3"></tab3>

                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_transfer";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import tab3 from "@/components/common/tabs/tabs_transfer_options/tab_filter";
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    data: function () {
        return {
            activeName: "first",
            optionDialogShow: false,
            tabs: [{
                name: this.$t('language.cloudTransfer.transfer')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                replace: 2,
                isRemove: 0,
                isKeep: 0,
                isChar: 1,
            },
            item: '',
            itemIndex: -1
        };
    },
    methods: {
        caseOption(number) {
            let value;
            switch (number) {
                case 2:
                    value = this.$t('language.popup.skipFile');
                    break;
                case 3:
                    value = this.$t('language.popup.sourceNewer');
                    break;
                case 1:
                    value = this.$t('language.popup.diffSize');
                    break;
                case 5:
                    value = this.$t('language.popup.sourceAll');
                    break;
                case 4:
                    value = this.$t('language.popup.overWrite');
                    break;
                case 0:
                    value = this.$t('language.popup.rename');
                    break;
            }
            return value;
        },
        optionSubmit() {
            //保存用户所选择的数据并触发父组件的事件
            delete this.options.matched;
            delete this.options.pattern;
            let user = commonUtils.getUser();
            //当用户勾选了邮箱但没有填邮箱
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "taskTransferOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
            }
            if (!this.item.options.email && this.options.email &&this.item.sources&& this.item.sources.length >= 10 && this.item.type == 1) {
                this.$parent.$refs.noticeDialog.noticeShow = true;
                this.$parent.$refs.noticeDialog.transferFlag = 3;
            } else {
                this.optionSubmitDetail();
            }
        },
        optionSubmitDetail() {
            let user = commonUtils.getUser();
            //用户保存filter数据
            if (this.$refs.tab3.items.length) {
                //付费功能弹窗提醒
                if (!user.vip) {
                    this.$parent.$refs.upgradeDialog.upgradeShow = true;
                    this.$parent.$refs.upgradeDialog.reset();
                    this.$parent.$refs.upgradeDialog.filterShow = true;
                    return false;
                }
                if (this.$refs.tab3.radioCurrent == 0) {
                    this.options.pattern = 'exclude';
                } else if (this.$refs.tab3.radioCurrent == 1) {
                    this.options.pattern = 'include';
                }
                for (let i = 0; i < this.$refs.tab3.items.length; i++) {
                    if (this.options.matched) {
                        this.options.matched = this.options.matched + '*' + this.$refs.tab3.items[i] + '|';
                    } else {
                        this.options.matched = '*' + this.$refs.tab3.items[i] + '|';
                    }
                }
                let index = this.options.matched.lastIndexOf('|');
                this.options.matched = this.options.matched.substring(0, index);
            }
            this.updateOptionRequest();

        },
        updateOptionRequest() {
            let that = this;
            var updateData;
            let item = Object.assign({}, this.item);
            let schedules = this.item.schedules;
            let options = this.options;
            let schType;
            if (schedules) {
                schType = commonUtils.substringType(schedules.type);
                schedules.type = schType;
                if (schedules.type == 'Monthly' || schedules.type == '=Monthly') {
                    schedules.days = this.$parent.packageMonthDaysData(item);
                }
                if (schedules.type == 'Weekly' || schedules.type == '=Weekly') {
                    schedules.weeks = this.$parent.packageWeekDaysData(item);
                }
                if (item.type == 2) {
                    if (schedules.value) {
                        if (schedules.value.time instanceof Array) {
                            schedules.times = schedules.value.time;
                        } else {
                            schedules.times = [schedules.value.time];
                        }
                    }
                    delete schedules.value;
                }
                delete schedules.outDate;
            }
            let getData;
            if (this.item.groupId) {
                let gd = this.item.groupId;
                updateData = new taskTransferUtils.updateGdTaskData(gd, commonUtils.getUser().id, this.item.type, this.item.name, options, schedules);
            } else {
                let id = this.item.id;
                updateData = new taskTransferUtils.updateIdTaskData(id, commonUtils.getUser().id, this.item.type, this.item.name, options, schedules);
            }
            that.optionDialogShow = false;
            that.$parent.tasklistData[that.itemIndex].updateFlag = true;
            that.$parent.$forceUpdate();
            if(this.item.branchType!='businessTransfer'){
            this.Utils.doTasksRequest("update", updateData).then(result => {
                if (result.status == 200) {
                    if (item.groupId) {
                        getData = {
                            ud: commonUtils.getUser().id,
                            type: item.type,
                            gd: item.groupId
                        }
                    } else {
                        getData = {
                            ud: commonUtils.getUser().id,
                            type: item.type,
                            id: item.id,
                        }
                    }
                    that.Utils.doTasksRequest("get", getData).then(res => {
                        let data = that.$parent.tasklistData[that.itemIndex];
                        data.schedules = res.tasks[0].schedules;
                        data.options = res.tasks[0].options;
                        that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                        that.$parent.$forceUpdate();
                    });
                } else {
                    that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                    this.$toast({
                        text: this.$t('language.exception.' + result.reason),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                }
            });
            }else{
                delete updateData.type;
                this.Utils.doBusinessTransferRequest("update", updateData).then(res=>{
                         let data = that.$parent.tasklistData[that.itemIndex];
                         data.schedules = schedules;
                         data.options = options;
                         if(data.sources){
                             for(var i=0;i<data.sources.length;i++){
                                 data.sources[i].options=options;
                                 data.sources[i].schedules=schedules;
                             }
                         }
                         that.$parent.tasklistData[that.itemIndex].updateFlag = false;
                         that.$parent.$forceUpdate();
                }).catch(err =>{
					if (err.reason) {
					  err = that.$t('language.exception.' + err.reason)
					}
					that.$toast({
					  text: err,
					  type: 'fail',
					  idValue: "rightContBan"
					});
				});
            }


        },
        optionClose() {
            //还原用户之前选择的数据
            this.optionDialogShow = false;
        }
    }
};
</script>

<style>
#taskTransferOptions #tab-first,
#taskTransferOptions #tab-second {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
}

#taskTransferOptions #tab-third {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    top: 5Px !important;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#taskTransferOptions .el-tabs__content {
    height: 370px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_transfer_options_popup.vue